import { render } from "./UserProfileNameSvg.vue?vue&type=template&id=7dc7fe8f"
import script from "./UserProfileNameSvg.vue?vue&type=script&lang=js"
export * from "./UserProfileNameSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__